import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import Seo from '../components/Seo';
import { useT } from '../i18n/LanguageContext';

// Catch-all route for any URL that doesn't match a real page. Renders its own
// <Seo robots="noindex"> to override RouteMetadata's default index,follow —
// a broken link should never get indexed as if it were real content.
export default function NotFound() {
  const t = useT();
  return (
    <div className="pt-32 pb-24 min-h-[60vh] flex items-center justify-center bg-white">
      <Seo
        title={`${t('notFound.title')} | OWA Wild Adventure`}
        description={t('notFound.description')}
        robots="noindex,nofollow"
      />
      <div className="max-w-md mx-auto px-5 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#f7f9fb] mb-6">
          <Compass className="w-7 h-7 text-[#1fa5a3]" />
        </div>
        <h1 className="text-3xl font-bold text-[#14213d] mb-3">{t('notFound.title')}</h1>
        <p className="text-gray-600 mb-8">{t('notFound.description')}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-[#1fa5a3] px-6 py-3 text-sm font-semibold text-white hover:bg-[#188b89]">
            {t('notFound.home')}
          </Link>
          <Link to="/activities" className="inline-flex items-center gap-2 rounded-full border border-gray-200 px-6 py-3 text-sm font-semibold text-[#14213d] hover:border-[#1fa5a3] hover:text-[#1fa5a3]">
            {t('notFound.activities')}
          </Link>
        </div>
      </div>
    </div>
  );
}
